import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils/cn';

export function Container({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('container-page', className)} {...props} />;
}
